import { createAsyncThunk } from '@reduxjs/toolkit';
import { SetIncomePayload } from 'common/types';
import { Income, IIncomeBase } from '../../../common/entities';
import axios from '../../api/axiosClient';
import { endpoints } from '../../api/endpoints';

export const listIncomes = createAsyncThunk(
  'income/list',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get<Income[]>(endpoints.income);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const getIncome = createAsyncThunk(
  'income/get',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get<Income>(`${endpoints.income}/${id}`);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const addIncome = createAsyncThunk(
  'income/add',
  async (data: IIncomeBase, thunkAPI) => {
    try {
      const response = await axios.post(endpoints.income, data);
      thunkAPI.dispatch(listIncomes());
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e?.response?.data?.message);
    }
  }
);

export const updateIncome = createAsyncThunk(
  'income/update',
  async (data: { id: string; income: IIncomeBase }, thunkAPI) => {
    const { id, income } = data;
    try {
      const response = await axios.put(`${endpoints.income}/${id}`, income);
      thunkAPI.dispatch(listIncomes());
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e?.response?.data?.message);
    }
  }
);

export const deleteIncome = createAsyncThunk(
  'income/delete',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.delete(`${endpoints.income}/${id}`);
      thunkAPI.dispatch(listIncomes());
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e?.response?.data?.message);
    }
  }
);

export const setIncome = createAsyncThunk(
  'income/month/set',
  async (payload: SetIncomePayload, thunkAPI) => {
    try {
      const response = await axios.post(`${endpoints.incomeMonth}`, payload);
      thunkAPI.dispatch(listIncomes());
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e?.response?.data?.message);
    }
  }
);
